import React from 'react';
import { useQuery } from 'react-query';
import { getTeam } from '../../services/teamApi';
import Title from '../shared/Title';
import ItemCard from './ItemCard';
import Loading from '../shared/Loading';
import Alert from '../shared/Alert';
import GridLayout from './GridLayout';

const ManagementContainer = () => {
  const { isLoading, isError, data } = useQuery(
    ['management', { filters: { default: `$filter=TypePosition eq 'administrative'` }, order: [{ by: 'Name', type: 'asc' }] }],
    getTeam,
    {
      retry: false,
      refetchOnWindowFocus: false,
      refetchOnMount: false
    }
  );

  return (
    <>
      <Title text1="Management" text2="Team" colorForText={2} />
      {isLoading ? (
        <Loading isLight={true} />
      ) : isError ? (
        <Alert open={isError} severity="warning" message="Error loading data, try again later" />
      ) : data && data.data.length > 0 ? (
        <GridLayout gridClassName="grid xl:grid-cols-5 lg:grid-cols-5 md:grid-cols-3 grid-cols-2">
          {data.data.map((user) => (
            <ItemCard
              key={user.Id}
              link={user.LinkedIn}
              name={user.Name}
              photo={user.PhotoUrl}
              position={user.Position}
              classes="mt-4 border border-blue-500"
            />
          ))}
        </GridLayout>
      ) : (
        <Alert open={true} message="No information available at this time" severity="info" />
      )}
    </>
  );
};

export default ManagementContainer;
